import moment from "moment";
import {ORDER_ROUTES} from "../const/routes";
import {commons} from "@mc/mc-legacy";
import {HIGHEST_TIME, LOWEST_TIME} from "../const/const";

/**
 * Přečísluje předané položky od zadaného indexu tak, aby číslování bylo souvislé.
 * Modifikuje předané pole (in-place).
 *
 * @param items pole položek
 * @param key název atributu položky obsahující pořadí
 * @param index od kterého indexu přečíslovávat
 * @returns {Array<Object>} pole položek
 */
export function fixOrder(items, key = "order", index = 0) {
    for (let i = index; i < items.length; i++) {
        items[i] = {...items[i]};
        items[i][key] = i + 1;
    }
    return items;
}

/**
 * Přesune položku na daném indexu na nový index.
 * Modifikuje předané pole (in-place).
 *
 * @param items pole položek
 * @param fromIndex index položky k přesunu
 * @param toIndex nový index položky
 */
export function changePosition(items, fromIndex, toIndex) {
    const item = items[fromIndex];
    items.splice(fromIndex, 1);
    items.splice(toIndex, 0, item);
    return items;
}

/**
 * Vrátí ID z parametru v query jako číslo, nebo null.
 *
 * @param props props
 * @param key název parametru v query
 * @returns {*}
 */
export function getIdFromProps(props, key = "id") {
    try {
        let number = parseInt(props.match.params[key]);
        return isNaN(number) ? null : number;
    } catch (e) {
        return null;
    }
}

/**
 * Naformátuje datum do formátu DD.MM.YYYY, nebo předaného formátu.
 *
 * @param date vstupní datum
 * @param inputFormat volitelný formát vstupního data pokud vstup není ISO 8601
 * @param outputFormat volitelný formát výstupního data, implicitně DD.MM.YYYY
 * @returns {string} naformátované datum, pokud byl vstup validní
 */
// TODO berka nahradit z commons
export function formatDate(date, inputFormat, outputFormat = "DD.MM.YYYY") {
    const m = moment(date, inputFormat);
    return m.isValid() && m.format(outputFormat);
}

/**
 * Naformátuje čas do formátu HH:mm, nebo předaného formátu.
 *
 * @param time vstupní čas
 * @param inputFormat volitelný formát vstupního času pokud vstup není ISO 8601
 * @param outputFormat volitelný formát výstupního času, implicitně HH:mm
 * @returns {string} naformátovaný čas, pokud byl vstup validní
 */
// TODO berka nahradit z commons
export function formatTime(time, inputFormat, outputFormat = "HH:mm") {
    const m = moment(time, inputFormat);
    return m.isValid() && m.format(outputFormat);
}

/**
 * Naformátuje datum a čas do formátu DD.MM.YYYY HH:mm
 *
 * @param dateTime vstupní datum a čas
 * @param inputFormat volitelný formát vstupního data a/nebo času pokud vstup není ISO 8601
 * @param outputFormat volitelný formát výstupního data a/nebo času, implicitně DD.MM.YYYY HH:mm
 * @returns {string} naformátované datum a čas, pokud byl vstup validní
 */
// TODO berka nahradit z commons
export function formatDateTime(dateTime, inputFormat, outputFormat = "DD.MM.YYYY HH:mm") {
    const m = moment(dateTime, inputFormat);
    return m.isValid() && m.format(outputFormat);
}

/**
 * Převede čas ve formátu 16:37:21 na date objekt s dnešním datem a předaným časem v UTC.
 * @param timeStr čas
 */
export function timeStringToDate(timeStr) {
    if (timeStr instanceof Date) {
        timeStr = commons.removeDate(timeStr);
        return timeStr;
    }
    return moment.utc(timeStr, "HH:mm:ss").date(1).month(0).year(1900).toDate();
}

/**
 * Převede čas ve formátu 16:37:21.00 na date objekt s předaným časem v UTC.
 * @param time čas
 */
export function timeToDatetime(time) {
    if (!time) {
        return null;
    }
    const m = moment(time, "HH:mm:ss.SS");
    m.set({'year': 2018, 'month': 0, 'date': 1});
    m.add(m.utcOffset(), 'm').utc();
    return m.toDate();
}

// /**
//  * Vrátí instanci Moment s minimálním datem a nejbližší nižší minutou.
//  *
//  * @param m instance Moment
//  * @returns {Moment}
//  */
// export function retainHoursMinutesOnly(m: Moment) {
//     if (!moment.isMoment(m)) {
//         return;
//     }
//     m.year(1900);
//     m.month(0);
//     m.date(1);
//     m.second(0);
//     m.millisecond(0);
//     return m;
// }
//
// /**
//  * Nastaví dané instanci dnešní datum, zachová původní čas zaokrouhlený dolů na minuty.
//  *
//  * @param m instance Moment
//  * @returns {Moment} instance s dnešním datem a původním časem zaokrouhleným dolů na minuty
//  */
// export function makeTodayTrimToMinutes(m: Moment) {
//     if (!moment.isMoment(m)) {
//         return;
//     }
//     const today = moment();
//     m.year(today.year());
//     m.month(today.month());
//     m.date(today.date());
//     return m;
// }
//
// /**
//  * Zakrouhlí instanci Moment na nejbližší vyšší čas který odpovídá velikosti kroku.
//  * Příklady:
//  *  (14:12, 10) => 14:20
//  *  (14:12, 15) => 14:15
//  *  (14:12, 120) => 16:00
//  * @param m instance Moment
//  * @param step velikost kroku v minutách
//  * @returns {number}
//  */
// export function roundUpToNearestMinute(m: Moment, step: number) {
//     const roundedUp = Math.ceil(m.minute() / step) * step;
//     return m.minute(roundedUp).second(0).millisecond(0);
// }

/**
 * Přesměruje na zadaný krok objednávky.
 *
 * @param stepId textové ID kroku objednávky
 * @param props props
 */
export function redirectToOrderStep(stepId, props) {
    const route = ORDER_ROUTES.find(route => route.id === stepId);
    if (route) {
        props.history.push(route.path);
    }
}

/**
 * Přesměruje na krok objednávky s daným pořadím.
 *
 * @param stepCount pořadí kroku objednávky
 * @param props props
 */
export function redirectToOrderStepNumber(stepCount, props) {
    props.history.push(ORDER_ROUTES[stepCount - 1].path);
}

/**
 * Vrátí nastavený počet minut po kterém vyprší platnost rozpracované objednávky.
 *
 * @param authInfo objekt s authInfo
 */
export function getOrderTimeoutMinutes(authInfo) {
    return authInfo.data && authInfo.data.moduleInfos && authInfo.data.moduleInfos.CGO
        && authInfo.data.moduleInfos.CGO.configuration && authInfo.data.moduleInfos.CGO.configuration.objednavkaTimeout;
}

/**
 * Vrací true pokud jsou povoleny notifikace přes e-mail (nastavený connector v properties)
 *
 * @param authInfo objekt s authInfo
 */
export function isEmailNotificationsEnabled(authInfo) {
    return authInfo.data && authInfo.data.moduleInfos && authInfo.data.moduleInfos.CGO
        && authInfo.data.moduleInfos.CGO.configuration && authInfo.data.moduleInfos.CGO.configuration.emailEnabled;
}

/**
 * Vrací true pokud jsou povoleny notifikace přes SMS (nastavený connector v properties)
 *
 * @param authInfo objekt s authInfo
 */
export function isSmsNotificationsEnabled(authInfo) {
    return authInfo.data && authInfo.data.moduleInfos && authInfo.data.moduleInfos.CGO &&
        authInfo.data.moduleInfos.CGO.configuration && authInfo.data.moduleInfos.CGO.configuration.smsEnabled;
}

/**
 * Vrátí z předaných adres první nalezenou splňující jedno z kritérií, v tomto pořadí:
 * - Výchozí adresa společnosti
 * - Výchozí adresa uživatele
 * - Fakturační adresa uživatele

 * @param adresyList seznam adres
 */
export function getVychoziAdresa(adresyList) {
    let adresa;
    if (adresyList && adresyList.length > 0) {
        adresa = adresyList.find((a) => a.spolecnost && a.vychozi);
        if (!adresa) adresa = adresyList.find((a) => a.uzivatel && a.vychozi);
        if (!adresa) adresa = adresyList.find((a) => a.uzivatel && a.fakturacni);
        return adresa;
    }
}

/**
 * Vrati novou instanci moment, kde je datum 1900-01-01, a milisekundy nastaveny na 0
 * minuty a hodiny se nemeni
 *
 * @param m nenormalizovany moment
 */
export function normalizeMoment(m){
    const normMoment = moment(m);
    normMoment.year(1900);
    normMoment.month(0);
    normMoment.date(1);
    normMoment.second(0);
    normMoment.millisecond(0);
    return normMoment;
}

export function jeDatumVyzvednutiDnes(datumVyzvednuti) {
    if(datumVyzvednuti){
        const todayDay = moment().startOf('day');
        const selectedDay = moment(datumVyzvednuti).startOf('day');
        if (selectedDay.isSame(todayDay)) {
            return true;
        }
    }
    return false;
}

export function roundUpToNearestMinute(m, step) {
    const roundedUp = Math.ceil(m.minute() / step) * step;
    return m.minute(roundedUp);
}

// Vrátí minimální čas který může uživatel vybrat na základě nastavení firmy, pobočky a zadaného data vyzvednutí
export function getMinimalniCas(firma, pobocka, datumVyzvednuti) {
    const vyzvednutiDnes = jeDatumVyzvednutiDnes(datumVyzvednuti);
    const casZhotoveni = pobocka && pobocka.casZhotoveniZakazky || 0; // doba zpracovani objednavky v minutach
    const pobockaOtevira = normalizeMoment(moment(firma.zobrazovatCasOd || LOWEST_TIME));

    let min = pobockaOtevira;
    if(vyzvednutiDnes){
        // cas vyzvednuti je bud oteviraci doba pobocky, nebo aktualni cas, podle toho co je pozdeji
        min = moment.max(pobockaOtevira, normalizeMoment(moment()));
    }

    // pridame dobu zhotoveni objednavky
    min.add(casZhotoveni, 'minutes');

    const roundedTime = roundUpToNearestMinute(min, firma.krokCasMinut || 1);
    return roundedTime.toDate();
}

// Vrátí maximální čas který může uživatel vybrat na základě nastavení firmy  pobočky
export function getMaximalniCas(firma) {
    const maxCasDate = moment(firma.zobrazovatCasDo || HIGHEST_TIME);
    return maxCasDate.toDate();
}
